import { Routes } from '@angular/router';
import { isAuthGuard } from './features/authentication/guards/is-auth.guard';
import { AllowedOrganizationGuard } from '@core/guards/allowedOrganization/allowedOrganization.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./features/authentication/authentication.routing'),
  },
  {
    path: 'dashboard',
    canActivate: [isAuthGuard, AllowedOrganizationGuard],
    loadChildren: () => import('./core/layout/layout-board.module'),
  },
  {
    path: 'redirect',
    loadComponent: () =>
      import(
        './features/redirect/pages/redirect-handler/redirect-handler.component'
      ),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import(
        './features/redirect/pages/redirect-unauthorized/redirect-unauthorized.component'
      ),
  },
  // Route for handling unknown routes
  {
    path: '**',
    redirectTo: '/login/sso',
  },
];
